import bydleni from 'images/game/bydleni.png';
import jidlo from 'images/game/jidlo.png';
import doprava from 'images/game/doprava.png';
import domacnost from 'images/game/categories/domacnost';
import pece_o_sebe from 'images/game/categories/pece_o_sebe';
import komunikace_a_media from 'images/game/categories/komunikace_a_media';
import zdravi_a_sport from 'images/game/categories/zdravi_a_sport';
import vzdelavani_a_rozvoj from 'images/game/categories/vzdelavani_a_rozvoj';
import zabava from 'images/game/categories/zabava';
import pece_o_zvire from 'images/game/categories/pece_o_zvire';
import co_zivot_dal from 'images/game/categories/co_zivot_dal';
import kolo_1 from 'images/game/kolo_1';
import kolo_2 from 'images/game/kolo_2';
import kolo_3 from 'images/game/kolo_3';
import rozpocet from 'images/game/how_it_works/rozpocet';
import ulohy from 'images/game/how_it_works/ulohy';
import vytvorit_tim from 'images/game/how_it_works/vytvorit_tim';
import best_team from 'images/game/who_can_join/best_team';
import task_kinds from 'images/game/who_can_join/task_kinds';
import who from 'images/game/who_can_join/who';
import footer_guy_dark from 'images/game/footer-guy-dark';
import footer_guy_light from 'images/game/footer-guy-light';
import yourchance from 'images/game/yourchance';
import profil from 'images/game/profil';
import task_simple from 'images/game/task/abc';
import task_answered from 'images/game/task/answered'
import money_small from 'images/game/resources/money_small';
import money_tiny from 'images/game/resources/money_tiny';
import money_medium from 'images/game/resources/money_medium';
import satisfaction_tiny from 'images/game/resources/satisfaction_tiny';
import satisfaction_small from 'images/game/resources/satisfaction_small';
import satisfaction_medium from 'images/game/resources/satisfaction_medium';
import state from 'images/game/state';
import chechtaky from 'images/game/resources/chechtaky';
import creative from 'images/game/creative_task';
import finindex from 'images/game/fin_index';
import audio_video from 'images/game/bonus_tasks/audio_video';
import hry from 'images/game/bonus_tasks/hry';
import internet from 'images/game/bonus_tasks/internet';
import pracovni_listy from 'images/game/bonus_tasks/pracovni_listy';
import prezentace from 'images/game/bonus_tasks/prezentace';
import psane_slovo from 'images/game/bonus_tasks/psane_slovo';
import privydelky from 'images/game/categories/privydelky';
import financni_rezervy_a_investice from 'images/game/categories/financni_rezervy_a_investice';
import vanoce from 'images/game/categories/vanoce';
import broker_trust from 'images/game/pages/broker_trust';
import ceska_mincovna from 'images/game/pages/ceska_mincovna';
import goal_competition from 'images/game/pages/goal-competition';
import goal_game from 'images/game/pages/goal-game';
import logo_your_chance from 'images/game/pages/logo_your_chance';
import logo_fin_gram from 'images/game/pages/logo_fin_gram';
import logo_podnikavost from 'images/game/pages/logo_podnikavost';
import logo_rozpoctisito from 'images/game/pages/logo_rozpoctisito';
import logo_kapodav from 'images/game/pages/logo_kapodav';
import logo_nadace_drfg from 'images/game/pages/logo_nadace_drfg';
import rozpoctisito from 'images/game/logo_rozpoctisito';

import zs_2019_fin_gram from 'images/game/zs_2019/fin_gram';
import zs_2019_hry from 'images/game/zs_2019/hry';
import zs_2019_internet from 'images/game/zs_2019/internet';
import zs_2019_psane_slovo from 'images/game/zs_2019/psane_slovo';
import zs_2019_video from 'images/game/zs_2019/video';
import zs_2019_vydaje from 'images/game/zs_2019/vydaje';

export default {
    profil,
    yourchance,
    logo_your_chance,
    footer_guy_dark,
    footer_guy_light,
    how_it_works: {
        rozpocet,
        ulohy,
        vytvorit_tim
    },
    who_can_join: {
        best_team,
        task_kinds,
        who
    },
    bydleni,
    jidlo,
    doprava,
    categories: {
        domacnost,
        pece_o_sebe,
        komunikace_a_media,
        zdravi_a_sport,
        vzdelavani_a_rozvoj,
        zabava,
        co_zivot_dal,
        pece_o_zvire,
        privydelky,
        financni_rezervy_a_investice,
        vanoce
    },
    kolo_1,
    kolo_2,
    kolo_3,
    task: {
        task_simple,
        task_answered,
        creative
    },
    bonus_tasks: {
        audio_video,
        hry,
        internet,
        pracovni_listy,
        prezentace,
        psane_slovo,
        creative
    },
    resources: {
        money_medium,
        money_small,
        money_tiny,
        satisfaction_tiny,
        satisfaction_medium,
        satisfaction_small,
        chechtaky
    },
    state,
    finindex,
    pages: {
        broker_trust,
        ceska_mincovna,
        goal_competition,
        goal_game,
        logo_your_chance,
        logo_fin_gram,
        logo_podnikavost,
        logo_rozpoctisito,
        logo_kapodav,
        logo_nadace_drfg
    },
    rozpoctisito,
    zs_2019: {
        zs_2019_fin_gram,
        zs_2019_hry,
        zs_2019_internet,
        zs_2019_video,
        zs_2019_vydaje,
        zs_2019_psane_slovo
    }
}
